import { Injectable } from '@angular/core';
import { DEVELOPER_MODE } from '../constants/allox-constant';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class DeveloperService {
  get isDeveloper() { return localStorage.getItem(DEVELOPER_MODE) != null; }
  get version() { return environment.version; }
}
